export default {
  NODE_ENV: "production",
  API_ENDPOINT: "https://fathomless-reef-21167.herokuapp.com/api",
  API_TOKEN: "3be5bed9-7eec-47e0-a6f3-8b5abe4a0971",
  TOKEN_KEY: "3be5bed9-7eec-47e0-a6f3-8b5abe4a0971",
  ID_KEY: "user_id",
  JWT_SECRET: "106816c9-bcb5-4a05-9d51-4dda16a357c3",
};
